import Strapi from 'strapi-sdk-javascript'
// eslint-disable-next-line
console.log(process.env.VUE_APP_API_URL)
export const api = new Strapi(process.env.VUE_APP_API_URL)
